import React, { useEffect, useState } from 'react';
import { ConfigProvider, Layout, theme } from 'antd';
import MasterHeader from './MasterHeader';
import Sidebar from './Sidebar';
import { useUser } from '../../contexts/UserContext';
import { useSelector } from 'react-redux';
import Banner from "../banner/Banner";
const { Content } = Layout;

const MasterLayout = ({ children }) => {
    const { defaultAlgorithm, darkAlgorithm } = theme;
    const { userConfigs } = useUser();


   

    return (
        <ConfigProvider
            prefixCls="ex"
            iconPrefixCls='exicon'
            direction={userConfigs.direction}
            locale={userConfigs.locale}
            theme={{
                algorithm: userConfigs.dark ? darkAlgorithm : defaultAlgorithm,
                token: {
                    "fontFamily": userConfigs.localeName =='FA'?'yekan':"Helvetica",
                    "colorBgContainer": userConfigs.dark ? "#101318" : "#fff",
                    "colorPrimary": "#00bff3",
                    "colorInfo": "#00bff3"
                },
                "components": {
                    "Menu": {
                        "subMenuItemBg": "transparent",
                        "itemBg": "transparent",
                        "darkItemBg": "transparent",
                        "itemSelectedColor":userConfigs.dark ? "white" :"black",
                        "itemSelectedBg": "transparent",
                        "itemHoverColor": userConfigs.dark ? "white" :"black",
                        "itemHoverBg": "transparent",
                        "fontSize": 13,
                        //"itemColor": "#939AA4"
                    },
                    "Button": {
                        "colorBorder": "#2F3847",
                        "defaultShadow": "0 0 rgba(0, 0, 0, 0)"
                    },
                    "Select": {
                        "colorBorder": "#2F3847",
                        "boxShadowPopoverArrow": "0 0 rgba(0, 0, 0, 0)"
                    },
                    "Input": {
                        "colorBgContainer": "transparent",
                        "colorBorder": "#2F3847",
                        "activeShadow": "0 0 rgba(0, 0, 0, 0)"
                    },
                    "Slider": {
                        "railBg": "#B3BBC7",
                        "railHoverBg": "#C0C9D6",
                        "colorBgElevated": "#666768",
                        "dotActiveBorderColor": "#666768",
                        "colorPrimaryBorderHover": "#666768",
                        "handleColor": "#fff",
                        "handleActiveColor": "#fff",
                        "dotBorderColor": "#ffffff",
                        "handleSize": 13,
                        "handleLineWidth": 3,
                    }
                }
            }}>
            <Layout className={userConfigs.dark ? 'container dark' : 'container light'} lang={userConfigs.localeName}>
                <MasterHeader />
                <Layout className='main-layout'>
                    <Sidebar />
                    <Layout className='content-body'>
                        <Content id="content-scroll-target">
                            {children}
                        </Content>
                    </Layout>
                </Layout>
            </Layout>
        </ConfigProvider>
    );
};

export default MasterLayout;
